import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedFeatureComponentsModule } from '@digilize/shared/feature/components/src';
import { SharedUiComponentsModule } from '@digilize/shared/ui/components/src';
import { SharedUiMaterialModule } from '@digilize/shared/ui/material/src';
import { SharedUtilsDirectivesModule } from '@digilize/shared/utils/directives/src';
import { SharedUtilsPipesModule } from '@digilize/shared/utils/pipes/src';
import { TranslocoModule } from '@jsverse/transloco';
import { InlineSVGModule } from '@digilize/shared/ui/inline-svg/src';
import { LazyLoadImageModule } from 'ng-lazyload-image';

const MODULES = [
  CommonModule,
  SharedUtilsDirectivesModule,
  SharedUtilsPipesModule,
  SharedUiComponentsModule,
  SharedFeatureComponentsModule,
  SharedUiMaterialModule,
  InlineSVGModule,
  LazyLoadImageModule,
  FormsModule,
  ReactiveFormsModule,
  TranslocoModule,
  RouterModule,
];

const COMPONENTS = [];
@NgModule({
  declarations: [...COMPONENTS],
  imports: [...MODULES],
  exports: [...MODULES, ...COMPONENTS],
})
export class SharedModule {}
